module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"agree":"Соглашаюсь с условиями <a href=\u0027{url}\u0027>оферты</a>","button":{"activate":"Включить","pay":"Оплатить {amount}","cancel":"Отменить"},"currency":{"RUB":"рублей"},"errors":{"failed":"Не получилось активировать. Попробуйте позже."}}}')
  delete Component.options._Ctor
}
